module.exports = __webpack_public_path__ + "img/ellipsis-vertical-solid.2964ccc5.svg";